const SET_BANNER = (state, data) => {
  state.showPrebookingBanner = data.showPrebookingBanner
  state.showPromotionBanner = data.showPromotionBanner
  state.lastFetchDate = new Date().toString()
}
export default {
  SET_BANNER
}



// WEBPACK FOOTER //
// ./src/store/modules/banner/mutations.js